var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#2d97e9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#2d97e9",
    strokeOpacity: 0.64,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4401 19.84L33.2801 16L40 22.72L36.16 26.56M29.4401 19.84L16.3976 32.8824C16.143 33.137 16 33.4823 16 33.8424V40H22.1577C22.5177 40 22.863 39.857 23.1177 39.6023L36.16 26.56M29.4401 19.84L36.16 26.56",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.09136ec675b998d95a161e9ded765ffd.svg";
export { ForwardRef as ReactComponent };